import { fieldError } from '../fieldError';

export function requiredField(isRequired) {
  return value =>
    isRequired && !value ? fieldError('Este campo é obrigatório') : null;
}
